<template>
  <div class="page-container not-alone-plan plan invest-product-manage">
    <div class="left-container">
      <div class="left-wrapper-block alone-plan">
        <module-header title="投资产品管理">
          <div slot="rightCom" class="head-btn-wrap">
            <el-button type="primary" @click="addProduct"> 添加产品 </el-button>
            <el-button type="primary" @click="addStarProduct">
              选择明星产品
            </el-button>
          </div>
        </module-header>
        <div class="table-container">
          <TsTable
            ref="table"
            :table-data="tableData"
            :table-head="tableHead"
            :table-title-obj="{ hide: true }"
            :table-select-opt="tableSelectOpt"
            @on-table-select="handleTableSelect"
            @on-handle-table-btn="handleTableBtn"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @on-handle-filter="handleFilter"
            @on-handle-table-first="handleTableFirst"
          />
        </div>
      </div>
    </div>
    <invest-drawer ref="investDrawer" @success="resetTable" />
    <back-test ref="backTestDialog" @success="fetchAgain" />
    <star-product ref="starProduct" />
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import SplitPane from "vue-splitpane";
import moduleHeader from "@/components/moduleHeader/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import InvestDrawer from "./template/investDrawer.vue";
import BackTest from "./template/backTestDialog.vue";
import StarProduct from "./template/starProduct";
import TsTable from "@/components/TsTable/TsTable.vue";
import {
  fetchInvestProductPage,
  fetchSaveInvestProduct,
  fetchOnSale,
  fetchInvestProductTypeList,
} from "@/api/investProduct";

@Component({
  name: "pensionPlan",
  components: {
    SplitPane,
    moduleHeader,
    Pagination,
    InvestDrawer,
    BackTest,
    StarProduct,
    TsTable,
  },
})
export default class extends Vue {
  tableData = {
    data: [],
    currentPage: 0,
    pageSize: 20,
    total: 0,
    filterTags: {}
  };

  tableHead = [
    {
      type: "first",
      propName: "productName",
      labelName: "产品名称",
      options: {
        type: "search",
      },
    },
    {
      propName: "rootTypeName",
      labelName: "产品属性",
      options: {
        type: "select",
        optionArr: [],
      },
    },
    {
      propName: "productTypeName",
      labelName: "产品分类",
      options: {
        type: "select",
        optionArr: [],
      },
    },
    {
      propName: "currencyName",
      labelName: "投资币种",
    },
    {
      type: "first",
      propName: "backTestSet",
      labelName: "产品回测数据选择",
      filterBody: [
        {
          type: true,
          name: "调整",
        },
        {
          type: null,
          name: "添加",
        },
        {
          type: false,
          name: "添加",
        },
      ],
    },
    {
      type: "inputSelect",
      propName: "onSale",
      labelName: "上架",
      selectOptions: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        }
      ],
    },
    {
      type: "edit",
      labelName: "编辑",
      propName: "edit",
      options: {
        dropdown: false,
        arr: [
          {
            type: "del",
            name: "删除",
            btnType: "text",
          },
        ],
      },
    },
  ];

  tableSelectOpt = [
    {
      type: "error",
      name: "批量删除",
      icon: "el-icon-delete",
      color: "red",
    },
    {
      type: "info",
      name: "信息",
      icon: "el-icon-info",
      color: "blue",
    },
  ];


  showBackTestDialog(row) {
    this.$refs.backTestDialog.show(row);
  }

  deleteItem(row) {
    let msg = `是否删除${row.productName}?`;
    this.$confirm(msg, "删除产品", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        row.deleted = true;
        fetchSaveInvestProduct(row).then((res) => {
          if (res.success) {
            this.$message.success("删除成功!");
            this.resetTable();
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  editProduct(row) {
    this.$refs.investDrawer.show(row);
  }

  addProduct() {
    this.$refs.investDrawer.show();
  }

  addStarProduct() {
    this.$refs.starProduct.show();
  }

resetTable() {
  this.$refs.table.handleClearFilter()
  this.tableData.currentPage = 0
  this.tableData.pageSize = 20
}

  fetchAgain() {
    this.init();
  }

  init() {
    const { pageSize: size, currentPage: page, filterTags } = this.tableData;
    fetchInvestProductPage({
      page: page,
      size,
      ...filterTags,
    }).then((res) => {
      if (res.success) {
        res.data.content.forEach((item) => {
          item.onSale = item.onSale ? true : false;
        });
        this.tableData.data = res.data.content;
        this.tableData.total = res.data.totalElements;
      } else {
        this.$message({
          message: res.errorMsg,
          type: "error",
        });
      }
    });
  }

  mounted() {
    this.handleRes();
  }

  handleRes() {
    this.init();
    this.handleTypes();
  }

 /**
  *
  */
  async handleTypes() {
    let res = await fetchInvestProductTypeList();
    let productAttributes = [];
    let productTypes = [];
    if (res?.data) {
      res.data.forEach((item) => {
        productAttributes.push({
          label: item.typeName,
          id: item.id,
        });
        if (item.subProductTypes) {
          item.subProductTypes.forEach((v) => {
            productTypes.push({
              label: v.typeName,
              id: v.id,
            });
          });
        }
      });
    }
    this.tableHead[1].options.optionArr = productAttributes;
    this.tableHead[2].options.optionArr = productTypes;
  }

  /**
   *   点击下拉或者按钮按钮触发
   *    type 按钮类型
   *    tableItem 如果按钮存在表格中 tableItem就是当前项
   */
  handleTableBtn(type, tableItem) {
    if (type === "del") {
      this.deleteItem(tableItem);
    }
  }

  // 点击表格按钮文字
  handleTableFirst(row, column) {
    if (column.propName === "backTestSet") {
      this.showBackTestDialog(row);
    } else {
      this.editProduct(row);
    }
  }


  /**
   * handleFilter 过滤处理filter
   */
  handleFilter(tags) {
    let formObj = {};
    tags.forEach((item) => {
      const _value = item.name.split(":")[1];
      formObj[item.type] = _value;
    });
    this.tableData.filterTags = formObj
    this.init();
  }

  // 分页相关
  // 选择条数
  handleSizeChange(val) {
    this.tableData.pageSize = val;
    this.tableData.currentPage = 0;
    this.init();
  }

  // 当前第几页
  handleCurrentChange(val) {
    this.tableData.currentPage = val;
    this.init();
  }

  /**
   * 点击表格下拉框
   * value 值
   * type 类型
   * row 行信息
   */
  handleTableSelect(value, type, row) {
    fetchOnSale({
      onsale: value,
      productId: row.id,
    }).then((res) => {
      if (res.success) {
        this.$message.success("操作成功");
      } else {
        this.$message.success("操作失败");
      }
    });
  }
}
</script>

<style lang="scss">
.invest-product-manage {
  .table-container {
    .el-table .el-table__body td {
      color: $fontGray;
      font-size: 14px;
    }
    .el-table th > .cell {
      font-weight: 500;
      font-size: 14px;
      color: #3a3a3a;
    }
    .el-select .el-input {
      width: 110px;
    }
  }
}
</style>

<style lang="scss" scoped>
.head-btn-wrap {
  width: 100%;
  margin-top: 15px;
}
.left-container {
  background-color: $bgGray;
  .left-wrapper-block {
    background: $fff;
    .pension-form-wrapper {
      padding-top: 30px;
      margin-bottom: 30px;
    }
  }
  .top-icon {
    margin-left: 30px;
    width: 600px;
  }
  .table-container {
    margin-top: 30px;
  }
}
</style>
